import CryptoJS from "crypto-js";

const OTP_MESSAGE_AES_KEY = "Instant&Personal";

export function decodeJwtPayload(token) {
  if (!token || typeof token !== "string") {
    return null;
  }

  const [, payload] = token.split(".");
  if (!payload) {
    return null;
  }

  try {
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const paddedBase64 = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      "=",
    );
    const json = decodeURIComponent(
      atob(paddedBase64)
        .split("")
        .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, "0")}`)
        .join(""),
    );

    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function decryptOtpMessage(message) {
  if (!message || typeof message !== "string") {
    return "";
  }

  try {
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(message) },
      CryptoJS.enc.Utf8.parse(OTP_MESSAGE_AES_KEY),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      },
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch {
    return "";
  }
}

export function parseOtpMessage(message) {
  const decryptedMessage = decryptOtpMessage(message);
  const [statusMessage = "", statusCode = "", otp = ""] = decryptedMessage
    .split("|")
    .map((part) => part.trim());

  return {
    decryptedMessage,
    statusMessage,
    statusCode,
    otp,
    isVerificationPassed:
      statusMessage.toLowerCase() === "otp verification passed" &&
      statusCode === "200",
  };
}

export function getUserFromOtpResponse(data, fallbackIdentifier = "") {
  const decodedToken = decodeJwtPayload(data?.token);
  const user = {
    ...(decodedToken || {}),
    ...(data?.user || {}),
  };

  if (!decodedToken && !data?.user) {
    return null;
  }

  const subject = user.sub || "";
  const fallbackEmail = String(fallbackIdentifier).includes("@")
    ? fallbackIdentifier
    : "";
  const fallbackMobile = fallbackEmail ? "" : fallbackIdentifier;

  return {
    ...user,
    id: user.id || user.userId || user.user_id || user.uid || "",
    userId: user.userId || user.id || user.user_id || user.uid || "",
    email:
      user.email ||
      user.emailId ||
      (String(subject).includes("@") ? subject : "") ||
      fallbackEmail,
    mobile:
      user.mobile ||
      user.mobileNo ||
      user.phoneNo ||
      (!String(subject).includes("@") ? subject : "") ||
      fallbackMobile,
    role: user.role || "",
    token: data?.token,
  };
}

export function isAdminRole(role) {
  return String(role || "").toUpperCase() === "ADMIN";
}

export function getRoleRedirectPath(role) {
  switch (String(role || "").toUpperCase()) {
    case "ADMIN":
      return "/admin/dashboard";
    case "OWNER":
      return "/owner/portfolio";
    case "TENANT":
    case "TANENT":
      return "/tenant/portfolio";
    default:
      return "/";
  }
}
